import EmptyAction from './EmptyAction';

export default EmptyAction;
